import { makeStyles } from '@material-ui/core/styles';


export const useStyle = makeStyles({
    basicDataPanel: {
        marginBottom: "20px",
        marginRight: "10px",
        height:"95%"
    },
});
